module.exports = __webpack_public_path__ + "static/media/images-cl_logo5.e30f5768.png";